// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageTBFeatures-styles___h1--KL17H {
  text-align: left;
}

.pages-ManageTBFeatures-styles___paper--JL8X2 {
  padding: 64px 40px 32px;
  padding-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
}

.pages-ManageTBFeatures-styles___body--OcKd0 {
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
}

.pages-ManageTBFeatures-styles___header--HWXkw {
  text-align: left;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
}

.pages-ManageTBFeatures-styles___header--HWXkw h1 {
    margin: 0;
    font-family: 'Roboto';
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
  }

.pages-ManageTBFeatures-styles___header--HWXkw .pages-ManageTBFeatures-styles___addButton--rOABp {
    background: #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    width: 63px;
    height: 52px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
  }
`, "",{"version":3,"sources":["webpack://./pages/ManageTBFeatures/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAwBhC;;AAtBE;IACE,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.paper {\n  padding: 64px 40px 32px;\n  padding-bottom: 0;\n  border-radius: 0;\n  box-shadow: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  background-color: transparent;\n}\n\n.body {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  display: flex;\n}\n\n.header {\n  text-align: left;\n  padding-top: 30px;\n  display: flex;\n  justify-content: space-between;\n\n  h1 {\n    margin: 0;\n    font-family: 'Roboto';\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n\n  .addButton {\n    background: #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #ffffff;\n    letter-spacing: 0;\n    text-align: center;\n    width: 63px;\n    height: 52px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageTBFeatures-styles___h1--KL17H`,
	"paper": `pages-ManageTBFeatures-styles___paper--JL8X2`,
	"body": `pages-ManageTBFeatures-styles___body--OcKd0`,
	"header": `pages-ManageTBFeatures-styles___header--HWXkw`,
	"addButton": `pages-ManageTBFeatures-styles___addButton--rOABp`
};
module.exports = ___CSS_LOADER_EXPORT___;
